
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment-b2b/payment`;

export const paymentService = {

    getPaymentList: async function (invoiceNo: any, vendorCode: any, invoiceDate: any, startDate: any, endDate: any) {
        return axios.get(`${GATEWAY_URL}/payment_invoice_list`, {
            params: {
                AccountId: null,
                InvoiceNo: invoiceNo,
                VendorCode: vendorCode,
                InvoiceDate: invoiceDate,
                StartDate: startDate,
                EndDate: endDate
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getVendorLookups: async function () {
        return axios.get(`${GATEWAY_URL}/payment_customer_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    paymentTypeLookup: async function () {
        return axios.get(`${GATEWAY_URL}/payment_type_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    savePayment: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_payment`, values)
            .then((response) => {
                return response.data;
            });
    },

    getTransactions: async function (invoiceId: any) {
        return axios.get(`${GATEWAY_URL}/payment_transactions`, {
            params: {
                InvoiceId: invoiceId,
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    updatePayment: async function (values: any) {
        return axios.post(`${GATEWAY_URL}/update_payment`, values)
            .then((response) => {
                return response.data;
            });
    },
}

